
class HeaderBar {
  constructor(element, ...options) {
    this.defaults = {
      fixedClass: '-fixed',
      showClass: '-show',
      hideClass: '-hide',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.normalY = this.element.scrollTop + this.element.getBoundingClientRect().height;
    this.lastY = window.pageYOffset;
    this.timeout = false;
    this.bindEvents();
  }

  controlFixed() {
    const inViewport = (window.pageYOffset < this.normalY);
    const containsFixed = this.element.classList.contains(this.options.fixedClass);
    const containsShow = this.element.classList.contains(this.options.showClass);

    if(!this.timeout) {
      if(!containsFixed && !inViewport) {
        this.element.classList.add(this.options.fixedClass);
      }
      else if(containsFixed && inViewport) {
        if(containsShow) {
          this.element.classList.remove(this.options.showClass);
          this.element.classList.add(this.options.hideClass);

          this.timeout = setTimeout(() => {
            this.element.classList.remove(this.options.fixedClass, this.options.hideClass);
            this.timeout = false;
          }, 100);
        }
      }
    }

  }

  controlShow() {
    const containsFixed = this.element.classList.contains(this.options.fixedClass);
    const containsShow = this.element.classList.contains(this.options.showClass);

    if(!this.timeout) {
      if(containsFixed) {
        if(!containsShow && this.lastY > window.pageYOffset) {
          this.element.classList.remove(this.options.hideClass);
          this.element.classList.add(this.options.showClass);
        }
        else if(containsShow && this.lastY < window.pageYOffset) {
          this.element.classList.remove(this.options.showClass);
          this.element.classList.add(this.options.hideClass);
        }
      }
    }
  }

  handleFrame() {
    this.controlFixed();
    this.controlShow();

    this.lastY = window.pageYOffset;
    window.requestAnimationFrame(this.handleFrame.bind(this));
  }

  bindEvents() {
    window.requestAnimationFrame(this.handleFrame.bind(this));
  }
}
